import { memo } from 'react';

import { useNavigationConfig } from '~/components/Navigation/hooks/useNavigationConfig';
import { MenuContentProps } from '~/components/Navigation/types';
import { getFormattedName } from '../../../../utils/getFormattedName';
import MenuHeaderWithPopover from '../MenuHead/MenuHeaderWithPopover';
import SubMenuList from './SubMenuList';

const MenuContent = ({
  menuId,
  intl,
  subMenu = [],
  iconType,
  isMenuOpen,
  iconTypeKey,
  isCollapsed,
  activeRouteId,
  routeItemName,
  menuName,
  onMenuExpandHandler,
  isLoading,
  isSubMenuVisible,
}: MenuContentProps) => {
  const { navigationConfig } = useNavigationConfig();

  return navigationConfig[menuId] ? (
    <>
      <MenuHeaderWithPopover
        intl={intl}
        menuId={menuId}
        iconType={iconType}
        subMenu={subMenu}
        isLoading={isLoading}
        isSubMenuVisible={isSubMenuVisible}
        isMenuClosed={!isMenuOpen}
        iconTypeKey={iconTypeKey}
        isCollapsed={isCollapsed}
        isRouteActive={!!activeRouteId}
        activeRouteId={activeRouteId}
        menuName={getFormattedName({
          intl,
          menuId,
          messageConfig: navigationConfig[menuId],
          isExpanded: !isCollapsed,
        })}
        firstSubMenu={subMenu[0].link}
        handleClick={onMenuExpandHandler}
      />

      <div className="nav-menu-transition-wrapper">
        <div data-testid="navigation-menu-item-wrapper" className="nav-menu-item-wrapper">
          <SubMenuList
            menuId={menuId}
            subMenu={subMenu}
            intl={intl}
            activeRouteId={activeRouteId}
            routeItemName={routeItemName}
            isLoading={isLoading}
            isSubMenuVisible={isSubMenuVisible}
          />
        </div>
      </div>
    </>
  ) : null;
};

export default memo(MenuContent);
